<template>
    <!-- 查询输入框开始 -->
    <a-form
        ref="formRef"
        name="advanced_search"
        class="ant-advanced-search-form mySerachForm"
        :model="formState"
        @finish="onFinish"
      >
        <a-row :gutter="24">
        
            <a-col  :span="8"><a-form-item name="class_date_begin"  label="上课日期开始" >
              <a-input  class="input"  v-model:value="formState.class_date_begin" placeholder="请输入上课开始日期"></a-input>
            </a-form-item>
          </a-col>
          <a-col  :span="8"><a-form-item name="class_date_end"  label="上课日期结束" >
              <a-input  class="input"  v-model:value="formState.class_date_end" placeholder="请输入上课结束日期"></a-input>
            </a-form-item>
          </a-col>
         
        </a-row>
        <a-row>
          <a-col :span="24" style="text-align: right">
            <a-button type="primary" html-type="submit">查询</a-button>
            <a-button style="margin: 0 8px" @click="() => formRef.resetFields()">重置</a-button>
            <a-button type="primary" @click="showModel">新增</a-button>
          </a-col>
        </a-row>
      </a-form>
  
    <!-- 查询输入框结束 -->
  
    <a-table :columns="columns" :data-source="data" size="small" :pagination="false"  bordered>
      <template #bodyCell="{ column, text, record }">
        <template v-if="['name', 'age'].includes(column.dataIndex)">
          <div>
            <a-input
              v-if="editableData[record.id]"
              v-model:value="editableData[record.id][column.dataIndex]"
              style="margin: -5px 0"
            />
            <template v-else>
              {{ text }}
            </template>
          </div>
        </template>
        <template v-else-if="column.dataIndex === 'operation'">
          <div class="editable-row-operations">
            <span v-if="editableData[record.id]">
              <a-typography-link @click="save(record.id)">提交</a-typography-link>
              <a-popconfirm title="确定取消吗?" @confirm="cancel(record.id)">
                <a>取消</a>
              </a-popconfirm>
            </span>
            <span v-else>
              <!-- <a @click="edit(record.id)">更新</a> -->
              <a-popconfirm class="onDelete" title="确定删除吗?" @confirm="onDelete(record.id)"> <a>删除</a> </a-popconfirm>  
               <a  @click="onEdit(record.id)">编辑</a>
            </span>
          </div>
        </template>
      </template>
    </a-table>
    <a-pagination class="pagination" v-model:current="current" v-model:total="total"  v-model:pageSize="pageSize" :hideOnSinglePage="true" @change="onChange" @showSizeChange="showSizeChange" />
    
    <!-- 可编辑表格结束 -->
  
  </template>
  <script setup>
  import { cloneDeep } from 'lodash-es';
  import axios from  'axios'
  import {message} from 'ant-design-vue'
  import {reactive, ref,onMounted,toRefs} from 'vue'
  import { $statisticsList} from '../api/statistics.js';
  const onFinish = values => {
 loadData({pageNo:tableData.current,pageSize:tableData.pageSize});
};

  
  const formState = reactive({
  class_date_begin:'',
  class_date_end:'',
  
});
  const columns = [
  {
    title: '序号',
    dataIndex: 'serialNumber',  // 虚拟字段，无需数据中存在
    key: 'serialNumber',
    width: "5%",  // 固定宽度，避免序号列过宽
    align: 'center',  // 居中显示
    // 自定义渲染：index 是当前行在循环中的索引
    customRender: ({ index }) => `${index + 1}`,
  },

//   1、已预约课时：
// 2、已上课课时：
// 3、待上课课时：
// 4、已取消课时：
// 5、预约单位数量：
// 6、报名总人数：
// 7、签到总人数：

    {
      title: '已预约课时',
      dataIndex: 'stat1',
      width: '10%',
    },
    {
      title: '已上课课时',
      dataIndex: 'stat2',
      width: '10%',
    },
    {
      title: '待上课课时',
      dataIndex: 'stat3',
      width: '10%',
    },
    {
      title: '已取消课时',
      dataIndex: 'stat4',
      width: '10%',
    },
    {
      title: '预约单位数量',
      dataIndex: 'stat5',
      width: '10%',
    },
    {
      title: '报名总人数',
      dataIndex: 'stat6',
      width: '20%',
    },
    {
      title: '签到总人数',
      dataIndex: 'stat7',
      width: '10%',
    }
  ];
  let tableData =reactive({
          data:[],
          current:ref(1),
          total:ref(1),
          pageSize:10
  });
  //查询数据库
  let loadData=async (params)=>{
    params.class_date_begin=formState.class_date_begin;
    params.class_date_end=formState.class_date_end;
    let res=await $statisticsList(params);
    if(res.code=='success'){
        //取出数据data和总页数，分页使用
        console.log(res)
        let {total,pageSize,pageNo,list}=res.data
        tableData.data=list
        tableData.current=ref(pageNo)
        tableData.total=ref(total)
        tableData.pageSize=ref(pageSize)
    }
  }
  loadData({pageNo:1,pageSize:10}); 
  let {data,current,total,pageSize} =toRefs(tableData)
  
  
  function onChange(page, pageSize) {
    let params= {pageNo:page,pageSize:pageSize}
    loadData(params);
  }
  function showSizeChange(current, size){
    let params= {pageNo:current,pageSize:size}
    loadData(params);
  }
  </script>
  <style scoped>
  .editable-row-operations a {
    margin-right: 8px;
  }
  .pagination{
    margin-top: 40px;
    float: right;
  }
  
  .mySerachForm{
    margin-bottom: 20px;
    
    
  }
  .input{
      border-radius: 2px;
    }
    .onEdit{
      margin-left: 10px;
    }
  </style>